import { Navigate, useLocation } from "react-router-dom";
import { isAdmin } from "@prism/shared/constants";
import { useAuth } from "../context/AuthContext.jsx";

/**
 * Staff-only route guard — AdminRoute's equivalent that ALSO admits EMPLOYEE.
 * For staff surfaces like the per-client cockpit (/clients/:id) that employees
 * reach for their scoped clients. Client users are quietly redirected to /
 * (HomeRedirect, which sends each role to its own landing page) — same
 * no-403-page reasoning as AdminRoute — don't leak that staff tools exist.
 * This is UI chrome only: the backend independently enforces requireStaff +
 * EMPLOYEE clientScopes on the cockpit endpoints, so client logins can't
 * reach the data regardless.
 */
export function StaffRoute({ children }) {
  const { authenticated, user } = useAuth();
  const location = useLocation();

  if (!authenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!isAdmin(user?.role) && user?.role !== "EMPLOYEE") {
    return <Navigate to="/" replace />;
  }
  return children;
}
